export default __webpack_public_path__ + "coupon-set-codes-manual.ef86f2acfda1b59dbac208f9668695a8.svg";